import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductRangesComponent } from './product-ranges/product-ranges.component';
import { ProductRangeEditComponent } from './product-range-edit/product-range-edit.component';

const routes: Routes = [
    {
        path: '',
        component: ProductRangesComponent,
        data: {
            menuGroup: ['products'],
            colouredBackground: true,
            offset: true,
            showMenu: true,
            showHeader: true,
            showFooter: true,
            disableAuthTimeout: false,
        },
    },
    {
        path: 'edit/:slug',
        component: ProductRangeEditComponent,
        data: {
            menuGroup: ['products'],
            staticRoute: "/product-ranges",
            colouredBackground: true,
            offset: true,
            showMenu: true,
            showHeader: true,
            showFooter: true,
            disableAuthTimeout: false,
        },
    },

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ProductRangeRoutingModule {}
